var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 72,
    viewBox: "0 0 76 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard \\u2013 2",
    clipPath: "url(#clip-Artboard_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-39 -45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-24 -180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(76 236)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-229.654 -230.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M317.1,303.852H303.67a.5.5,0,0,0,0,1H317.1a1.391,1.391,0,0,1,1.389,1.39V317.93a1.39,1.39,0,0,1-1.389,1.389H298.67a1.391,1.391,0,0,1-1.39-1.389v-6.688a.5.5,0,0,0-1,0v6.688a2.392,2.392,0,0,0,2.39,2.389H317.1a2.391,2.391,0,0,0,2.389-2.389V306.242A2.392,2.392,0,0,0,317.1,303.852Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M313.555,307.981H302.2v8.209h11.35Zm-1,7.209H303.2v-6.209h9.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M316.152,321.25H299.608a.5.5,0,0,0,0,1h16.544a.5.5,0,0,0,0-1Z",
    transform: "translate(0 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M306.871,313.728l2.255-1.442a.221.221,0,0,0,0-.372l-2.255-1.442a.22.22,0,0,0-.339.186v2.884a.22.22,0,0,0,.339.186Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M302.157,305.707a4.167,4.167,0,1,0-4.167,4.167,4.167,4.167,0,0,0,4.167-4.167Zm-4.746,2.112a.933.933,0,0,1-.674-.284L295.7,306.5a.427.427,0,0,1,.605-.6l1.041,1.041a.105.105,0,0,0,.141-.01l2.018-2.69a.427.427,0,0,1,.683.512l-2.017,2.69a.944.944,0,0,1-.626.37,1.008,1.008,0,0,1-.134.006Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/views_icon.335fb2e6ac5eae30d786edc0a2b2af56.svg";
export { ForwardRef as ReactComponent };